import { FC } from 'react';
import { Table } from 'components';
import { Information } from 'types';

import { Pagination } from 'antd';
import { dayjs } from 'libs';
import { HistoryReceivingStyled } from 'pages/Notifications/styles';

type Props = {
  data: {
    notifications: Information[];
    nextPage: number | null;
    prevPage: number | null;
    lastPage: number | null;
    count: number;
    currentPage: number;
  };
  loading: boolean;
  setCurrent: (page: number) => void;
};

const HistoryReceiving: FC<Props> = ({ data, setCurrent, loading }) => {
  const pageSize = 12;
  return (
    <HistoryReceivingStyled style={{ display: 'block' }}>
      <Table<Information>
        columns={columns}
        dataSource={(data.notifications && data.notifications) || []}
        loading={loading}
        rowKey={({ information_id }) => information_id}
      />
      {data?.notifications && data?.notifications.length > 1 && (
        <Pagination
          className="pagination"
          current={data?.currentPage}
          onChange={(page) => setCurrent(page)}
          pageSize={pageSize}
          total={data?.count}
          showSizeChanger={false}
        />
      )}
    </HistoryReceivingStyled>
  );
};

export default HistoryReceiving;

const columns = [
  {
    title: '受信日時',
    dataIndex: 'date',
    width: '17%',
    render: (date: number) => <>{dayjs(date).format('YYYY/MM/DD HH:mm')}</>,
  },
  {
    title: '送信元',
    dataIndex: 'cooperator_company_name',
    width: '15%',
    render: (cooperator_company_name: string) => (
      <div className="border-left">{cooperator_company_name}</div>
    ),
  },
  {
    title: '現場名',
    dataIndex: 'site_name',
    width: '15%',
    render: (site_name: string) => <div className="border-left">{site_name}</div>,
  },
  {
    title: '内容',
    dataIndex: 'content',
    render: (content: string) => (
      <div className="border-left" style={{ wordBreak: 'break-word' }}>
        {content}
      </div>
    ),
  },
];
